var ViewAsyncAdDesktop = function(){

	/* Front Cover Ad */
	//window.addEventListener('show-async-banner', _desktopAdBetweenPages, true);
	window.addEventListener('show-async-banner-css', _desktopAdBetweenPages, true);

	function _desktopAdBetweenPages() {
		var rightBtnSelector = document.querySelector(".view-buttons-wrap.right"),
			asyncBannerContainer = document.querySelectorAll(".desktop-async-banner")[0],
			overlayContainer = $(".async-banner-overlay"),
			currentUrl = location.origin + location.pathname,
			urlsWithShowedBanner = sessionStorage.urlsWithShowedBanner ? JSON.parse(sessionStorage.urlsWithShowedBanner) : [];

		if(typeof asyncBannerContainer === 'undefined' || typeof asyncDesktopViewAd === "undefined" || asyncDesktopViewAd.key.trim() !== 'desktop_async_banner' || 
			checkUrlIsInArray() || gal.currentState.currentPage === 6 || gal.currentState.currentPage === 15){
			return;
		}

		function checkUrlIsInArray() {
			return urlsWithShowedBanner.indexOf(currentUrl) > -1;  
		}
		
		if (!checkUrlIsInArray()) {
			urlsWithShowedBanner.push(currentUrl);
		}
		sessionStorage.setItem("urlsWithShowedBanner", JSON.stringify(urlsWithShowedBanner));

		if($(".pswp__img:eq(0)").length && rightBtnSelector.offsetHeight < $(".pswp__img:eq(0)").height()) {
			overlayContainer.css("height", $(".pswp__img:eq(0)").height() + 2);
			overlayContainer.css("top", $(".pswp__img:eq(0)").offset().top - 1);
		} else {
			overlayContainer.css("height", rightBtnSelector.offsetHeight + 2);
			overlayContainer.css("top", rightBtnSelector.offsetTop - 1);

		}
		overlayContainer.removeClass("hide");
		
		function removeAsyncBanner(e) {
			overlayContainer.addClass("hide");
			overlayContainer.remove();
		}

		$(".async-banner-btn, #next-page, #prev-page").click(function(e){
			if ($(e.target).closest(".view-buttons-wrap").hasClass("left")) {
				gal.gallery.goTo(gal.currentState.currentPage + 1);
			} else if ($(e.target).closest(".view-buttons-wrap").hasClass("right")) {
				gal.gallery.goTo(gal.currentState.currentPage - 1);
			}

			removeAsyncBanner(e);
			$("#next-page, #prev-page").off("click");
		});

		document.addEventListener("keydown", checkKey);

		function checkKey(e) {
			if (e.keyCode == '37' || e.keyCode == '39') {
				e.keyCode == '37' ? gal.gallery.goTo(gal.currentState.currentPage + 1) : gal.gallery.goTo(gal.currentState.currentPage - 1);
				removeAsyncBanner(e);
				document.removeEventListener("keydown", checkKey);
			}
		}
        
		window.removeEventListener('show-async-banner', _desktopAdBetweenPages, true);
    }
};